module.exports = __webpack_public_path__ + "static/media/ic-slideshow-arrow.709f84b3.svg";